/* eslint-disable @typescript-eslint/naming-convention */

export enum ElementType {
  ELLIPSE,
  CIRCLE,
  BOX,
  PATH,
  LINE,
  FREE,
  POLYLINE,
  POLYGON,
  TRIANGLE,
  RIGHT_TRIANGLE,
  ISOSCELES_TRIANGLE,
  RECTANGLE,
  PARALLELOGRAM,
  ISOSCELES_TRAPEZOID,
  GROUP,
  FOREIGN_OBJECT,
  TEXT_BOX,
  TEXT,
  IMAGE,
  VIDEO,
  COORDINATE_PLANE,
  NUMBER_LINE,
  COORDINATE_PLANE2,
  NUMBER_LINE2,
  GRAPHIC,
  PARABOLA,
  ABSOLUTE_VALUE,
  SQUARE_ROOT,
  SIN,
  COS,
  TAN,
  RAY2,
  SEGMENT,
  TABLE,
  MESH,
  CUBE,
  PYRAMID,
  PRISM,
  CYLINDER,
  CONE,
  SPHERE,
}
